package com.appcreator.blueprint.components.data

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.AlwaysContainer
import com.appcreator.blueprint.core.Component
import com.appcreator.blueprint.core.ComponentClass
import com.appcreator.blueprint.core.DisplayIf
import com.appcreator.blueprint.core.GenericDefault
import com.appcreator.blueprint.core.InputProperty
import com.appcreator.blueprint.core.LoaderConfig
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("Loading")
@ComponentClass(
    group = "Data",
    title = "Data Loader",
    description = "Loads data",
    availableFrom = "0.0.1"
)
data class LoadingComponent(

    override val _nodeId: String?,
    override val _nodeLabel: String?,
    override val _nodeRelativeId: String?,

    @InputProperty(
        title = "Loader",
        availableFrom = "0.0.1"
    )
    val config: LoaderConfig?,
    @InputProperty(
        title = "Component",
        availableFrom = "0.0.1"
    )
    @AlwaysContainer
    val content: Component?,

    @InputProperty(
        title = "On Load Action",
        availableFrom = "0.0.1"
    )
    val action: Action?,

    @InputProperty(
        section = "Advanced",
        title = "Pull to refresh",
        availableFrom = "0.0.1"
    )
    val pullToRefresh: Boolean?,

    @InputProperty(
        section = "Advanced",
        title = "Error type",
        availableFrom = "0.0.1"
    )
    @GenericDefault("LoadingComponent.ViewType.Default")
    val errorView: ViewType?,

    @InputProperty(
        section = "Advanced",
        title = "Error content",
        availableFrom = "0.0.1"
    )
    @DisplayIf("errorView.value == LoadingComponent.ViewType.Custom.name")
    @AlwaysContainer
    val errorContent: Component?,

    @InputProperty(
        section = "Advanced",
        title = "Loader type",
        availableFrom = "0.0.1"
    )
    @GenericDefault("LoadingComponent.ViewType.Default")
    val loadingView: ViewType?,

    @InputProperty(
        section = "Advanced",
        title = "Loader content",
        availableFrom = "0.0.1"
    )
    @DisplayIf("loadingView.value == LoadingComponent.ViewType.Custom.name")
    @AlwaysContainer
    val loadingContent: Component?,

    @InputProperty(
        section = "Advanced",
        title = "Reload From Trigger",
        availableFrom = "0.0.1"
    )
    val reloadTrigger: String?,

    @InputProperty(
        section = "Preview",
        title = "Display content",
        availableFrom = "0.0.1"
    )
    @GenericDefault("LoadingComponent.DisplayInPreview.Loaded")
    val displayInPreview: DisplayInPreview?,

): Component {

    enum class ViewType {
        Default,
        Nothing,
        Custom
    }

    enum class DisplayInPreview {
        Loading,
        Loaded,
        Error
    }

}
